import { Link } from 'react-router-dom';
import Reveal from '@/components/feature/Reveal';
import SectionHeader from './SectionHeader';

const cards = [
  {
    icon: 'ri-robot-2-line',
    title: 'IA y Agentes Inteligentes',
    desc: 'Diseñamos agentes de IA capaces de integrarse con las herramientas y procesos de una organización para consultar información, automatizar tareas, asistir equipos y ejecutar acciones.',
    services: [
      'Agentes IA empresariales',
      'Asistentes internos',
      'Automatización mediante IA',
      'IA conectada a ERP',
      'RAG y bases de conocimiento',
      'Integración con LLMs',
    ],
    cta: 'Explorar soluciones de IA',
    to: '/inteligencia-artificial',
    accent: 'text-accent-400',
    glow: 'hover:border-accent-500/50',
  },
  {
    icon: 'ri-code-box-line',
    title: 'Software a medida',
    desc: 'Construimos plataformas digitales desde cero y modernizamos sistemas existentes, diseñando arquitecturas preparadas para crecer.',
    services: [
      'Plataformas SaaS',
      'Sistemas empresariales',
      'Aplicaciones web y móviles',
      'Portales administrativos',
      'Arquitecturas multi-tenant',
      'APIs y microservicios',
    ],
    cta: 'Conoce cómo desarrollamos',
    to: '/desarrollo-software',
    accent: 'text-primary-400',
    glow: 'hover:border-primary-500/50',
  },
  {
    icon: 'ri-git-merge-line',
    title: 'Sistemas que finalmente conversan',
    desc: 'Conectamos ERP, plataformas, APIs, medios de pago y servicios externos para eliminar procesos manuales y crear ecosistemas tecnológicos integrados.',
    services: [
      'SAP Business One',
      'Service Layer y DI API',
      'ERP, WMS, APIs REST',
      'Webhooks y sistemas externos',
      'Transbank, Mercado Pago',
      'Stripe e integraciones custom',
    ],
    cta: 'Ver integraciones',
    to: '/integraciones',
    accent: 'text-secondary-400',
    glow: 'hover:border-secondary-500/50',
  },
  {
    icon: 'ri-cloud-line',
    title: 'Arquitectura preparada para crecer',
    desc: 'Diseñamos arquitecturas modernas, escalables y mantenibles para productos digitales y sistemas empresariales.',
    services: [
      'Arquitectura de software',
      'SaaS multi-tenant',
      'Docker y Cloud',
      'Infraestructura',
      'Diseño de APIs y seguridad',
      'Escalabilidad y observabilidad',
    ],
    cta: 'Diseñar mi arquitectura',
    to: '/arquitectura',
    accent: 'text-accent-400',
    glow: 'hover:border-accent-500/50',
  },
];

export default function WhatWeDo() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="Qué hacemos"
          title="Tecnología aplicada a problemas reales"
          subtitle="No implementamos tecnología porque esté de moda. La usamos para resolver procesos, integrar sistemas, automatizar operaciones y construir nuevos productos."
        />

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
          {cards.map((card, i) => (
            <Reveal key={card.title} delay={i * 100}>
              <div
                className={`group h-full flex flex-col rounded-lg border border-background-700/60 bg-background-900/50 backdrop-blur p-7 md:p-8 transition-all duration-300 hover:-translate-y-1 ${card.glow}`}
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-background-800 border border-background-700/60">
                  <i className={`${card.icon} ${card.accent} text-2xl`}></i>
                </div>
                <h3 className="mt-5 text-xl md:text-2xl font-bold font-heading text-foreground-950">
                  {card.title}
                </h3>
                <p className="mt-3 text-sm md:text-base text-foreground-500 leading-relaxed">
                  {card.desc}
                </p>
                <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2.5">
                  {card.services.map((s) => (
                    <li
                      key={s}
                      className="flex items-start gap-2 text-sm text-foreground-400"
                    >
                      <i className="ri-check-line text-primary-400 mt-0.5"></i>
                      {s}
                    </li>
                  ))}
                </ul>
                <Link
                  to={card.to}
                  className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-foreground-900 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {card.cta}
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}